export default "__VITE_ASSET__Cmi4Y64L__"